// Default center: Łódź, Poland
export const defaultCenter = { lat: 51.7592, lng: 19.4560 };
export const defaultZoom = 12;

// Maximum markers to display on screen
export const MAX_VISIBLE_MARKERS = 100;

/** Minimalna liczba znaków zapytania w polu „Szukaj” na mapie (adres / miasto) przed geokodowaniem */
export const MAP_SEARCH_QUERY_MIN_LENGTH = 3;

// Map zoom limits
export const minZoom = 9;  // Minimalne oddalenie (cała Polska)
export const maxZoom = 20; // Maksymalne przybliżenie (lekko zwiększone)

// Poland bounds (approximate)
export const polandBounds = {
  north: 54.8358,  // Północna granica
  south: 49.0020,  // Południowa granica
  east: 24.1458,   // Wschodnia granica
  west: 14.1229,   // Zachodnia granica
};

// Map container style
export const mapContainerStyle = {
  width: '100%',
  height: '100%',
};
